<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              id="farm_labor_catchs"
              clearable
              @change="showCalendar()"
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="farm_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('common_words.date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm date-form required-date"
              v-model="date_sel"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
              @change="handleDateChange(date_sel)"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-xl-3">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <button
              class="btn btn-success custom-shadow-btn btn-filter"
              @click="validate"
            >
              {{ $t('common_words.generate') }}
            </button>
          </div>
        </div>
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert.message }}
      </div>
      <card
        class="custom-shadow-card-header mt-4"
        :title="$t('production.capture_labors')"
        v-if="showLaborCatch && !messageAlert"
      >
        <div class="mt-4 px-3">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table
                class="table table-striped table-bordered not-last-td table-data"
              >
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>{{ $t('common_words.origin_farm') }} *</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('labor.worker') }} *
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('labor.labours_done') }} *
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.shift_type') }} *
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.allotment') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.quantity') }} *
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('labor.hour_numbers') }} *
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.order_service') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.observation') }}
                    </th>
                    <th
                      v-if="!messageAlert"
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '100px', marginTop: '6px' }"
                    >
                      <strong>{{ $t('common_words.options') }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="index in model.nLaborsCatch" :key="index">
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-farm_id_origin shadow-sm"
                        size="large"
                        v-model="model.farm_id_origin[index - 1]"
                        @change="
                          getWorkerByFarm(
                            model.farm_id_origin[index - 1],
                            index,
                            model.farm_id_origin[index - 1]
                          )
                        "
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in farms"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 180px"
                        class="select-primary custom-width-select required-worker shadow-sm"
                        size="large"
                        v-model="model.worker_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <!-- :label="option.name" -->
                        <el-option
                          v-for="(option, idx) in workersByFarm[index - 1]"
                          class="select-primary"
                          :value="option.id"
                          :label="`${option.code}-${option.name}`"
                          :key="idx"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 200px"
                        class="select-primary custom-width-select required-activities shadow-sm"
                        size="large"
                        v-model="model.activities_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                        @change="
                          captureType(model.activities_id[index - 1], index)
                        "
                      >
                        <el-option
                          v-for="(option, index) in activities"
                          class="select-primary"
                          :value="option.id"
                          :label="`${option.code}-${option.name}(${option.unit_production_name})`"
                          :key="index"
                        >
                        </el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 140px"
                        class="select-primary custom-width-select required-timeTypes shadow-sm"
                        size="large"
                        v-model="model.time_type_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in timeTypes"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="index"
                        >
                        </el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        :disabled="typeCaptureValidate[index - 1]"
                        clearable
                        filterable
                        style="min-width: 90px"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="large"
                        v-model="model.lot_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in lots"
                          class="select-primary"
                          :value="option.id"
                          :label="`${option.name} [Area:${option.area}]`"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="number"
                        step="0.01"
                        min="0"
                        ref="quantity"
                        style="min-width: 90px"
                        class="shadow-sm text-center mt-3 required-quantity"
                        v-model="model.quantity[index - 1]"
                        name="common_words.quantity"
                        v-validate="modelValidations.quantity"
                        :error="getError('common_words.quantity', true, index)"
                      >
                      </fg-input>
                    </td>
                    <td class="text-center">
                      <fg-input
                        step="0.01"
                        min="1"
                        max="12"
                        type="number"
                        ref="number_hour"
                        style="min-width: 90px"
                        class="shadow-sm text-center mt-3 required-number_hour"
                        v-model="model.number_hour[index - 1]"
                        name="labor.hour_numbers"
                        v-validate="modelValidations.number_hour"
                        :error="getError('labor.hour_numbers', true, index)"
                        @change="
                          validateTotalNumberHours(
                            index - 1,
                            model.worker_id[index - 1],
                            model.farm_id_origin[index - 1]
                          )
                        "
                      >
                      </fg-input>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="text"
                        style="min-width: 90px"
                        class="shadow-sm text-center mt-3"
                        v-model="model.service_order[index - 1]"
                      >
                      </fg-input>
                    </td>
                    <td class="text-center">
                      <el-input
                        clearable
                        type="textarea"
                        class="shadow-sm"
                        ref="observation"
                        style="min-width: 140px"
                        v-model="model.observation_details[index - 1]"
                      >
                      </el-input>
                    </td>
                    <td
                      v-if="!messageAlert"
                      class="text-center"
                      style="min-width: 90px"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click.prevent="model.nLaborsCatch++"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="model.nLaborsCatch > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(index - 1)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 pr-0 text-right" v-if="isCreate() || isUpdate()">
              <button
                class="btn btn-success custom-shadow-btn btn-filter m-4"
                @click="validateEveryDetail()"
              >
                {{ $t('common_words.save') }}
              </button>
            </div>
            <div class="col-6 pl-0 text-left" v-if="isDelete()">
              <button
                class="btn btn-danger custom-shadow-btn btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import {
  isset,
  capitalizeString,
  resetObjectProperties,
  ifExistNumber,
} from 'src/util/Util';
import i18n from 'src/i18n';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinLocation from 'src/util/mixinLocation';
import MixinMenu from 'src/util/mixinMenu';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      model: {
        id: null,
        labor_header_id: [],
        labor_detail_id: [],
        farm_id: [],
        date_save: [],
        latitude: [],
        longitude: [],
        altitude: [],
        add_increment: [],
        full_date: [],
        hour: [],
        closing: [],
        farm_id_origin: [],
        worker_id: [],
        signature: [],
        lot_id: [],
        activities_id: [],
        time_type_id: [],
        production_unit: [],
        quantity: [],
        number_hour: [],
        service_order: [],
        observation_details: [],
        nLaborsCatch: 1,
        user_id: [],
        delete_labors_details_id: [],
        delete_labors_headers_id: [],
        date_sel: null,
      },
      modelValidations: {
        quantity: {
          decimal: true,
          min_value: 0,
          required: true,
        },
        number_hour: {
          decimal: true,
          min_value: 1,
          max_value: 12,
          required: true,
        },
      },
      catch_type: [],
      farm_sel: null,
      date_sel: null,
      calendar_sel: null,
      location: null,
      workers: [],
      workersByFarm: [[]],
      dayOfWeek: '',
      farms: [],
      lots: [],
      activitiesGroup: [],
      activities: [],
      timeTypes: [],
      messageAlert: null,
      showLaborCatch: false,
      typeCaptureValidate: [],
      totalHours: 0,
      isShowCalendar: false,
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinForm, mixinLocation, MixinMenu],
  watch: {
    '$i18n.locale': 'forceRerender',
  },
  computed: {
    calendars() {
      if (this.farm_sel) {
        let calendars = [];
        this.farms.forEach((element) => {
          if (element.id == this.farm_sel) {
            calendars = element.calendars;
          }
        });
        return calendars;
      } else {
        return [];
      }
    },
  },
  methods: {
    handleDateChange(date) {
      if (isset(date)) {
        const days = [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ];
        const selectedDay = new Date(date).getDay();
        this.dayOfWeek = days[selectedDay];
      }
    },
    async getLocation() {
      const locationData = await this.getPosition();
      return {
        lat: locationData.lat,
        lng: locationData.lng,
        alt: locationData.alt,
      };
    },
    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.calendar_sel = null;
      this.showLaborCatch = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.farm_sel
      );
      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }
      this.isShowCalendar = false;
    },
    cleanForm() {
      if (this.messageAlert && !this.messageAlert.show)
        this.messageAlert = null;
      this.model.farm_id = [];
      this.model.date_save = [];
      this.model.latitude = [];
      this.model.longitude = [];
      this.model.altitude = [];
      this.model.hour = [];
      this.model.closing = [];
      this.model.farm_id_origin = [];
      this.model.worker_id = [];
      this.model.signature = [];
      this.model.lot_id = [];
      this.model.activities_id = [];
      this.model.time_type_id = [];
      this.model.production_unit = [];
      this.model.quantity = [];
      this.model.number_hour = [];
      this.model.service_order = [];
      this.model.observation_details = [];
      this.model.user_id = [];
      this.model.full_date = [];
      this.catch_type = [];
      this.model.labor_header_id = [];
      this.model.id = null;
      this.model.labor_detail_id = [];
      this.model.nLaborsCatch = 1;
      this.model.add_increment = [];
      this.model.delete_labors_details_id = [];
      this.model.delete_labors_headers_id = [];
      this.workersByFarm = [[]];
      this.typeCaptureValidate = [];
    },
    loadData() {
      this.showHideLoading(true);
      this.showLaborCatch = true;
      let data = {
        farm_id: this.farm_sel,
        date_save: this.date_sel,
        user_id: this.$store.state.auth.user.id,
        route: 'works/workers/catchlists',
      };
      Promise.all([
        Axios.getMasters('farms/farms/lots/' + this.farm_sel),
        Axios.postMasters(data),
      ])
        .then((response) => {
          const [responseLots, responseLaborCatchs] = response;
          this.lots = responseLots.data.data;
          const laborCatchs = responseLaborCatchs.data.data;
          if (isset(laborCatchs)) {
            this.model.nLaborsCatch = 0;

            laborCatchs.forEach((laborHeader) => {
              laborHeader.labor_details.forEach((laborDetail) => {
                let lotValue = 0;
                lotValue = laborDetail.lot_id ? laborDetail.lot_id : 0;

                this.model.labor_header_id.push(laborHeader.id);
                this.model.farm_id.push(laborHeader.farm_id);
                this.model.hour.push(laborHeader.hour);
                this.model.closing.push(laborHeader.closing);
                this.model.signature.push(laborHeader.signature);
                this.model.date_save.push(laborHeader.date_save);
                this.model.user_id.push(laborHeader.user_id);
                this.model.worker_id.push(laborHeader.worker_id);
                this.model.farm_id_origin.push(laborHeader.farm_id_origin);
                this.getWorkerByFarm(
                  laborHeader.farm_id_origin,
                  this.model.nLaborsCatch + 1
                );

                this.model.labor_detail_id.push(laborDetail.id);
                this.model.full_date.push(laborDetail.full_date);
                this.model.activities_id.push(laborDetail.activity_id);
                this.model.time_type_id.push(laborDetail.time_type_id);
                this.model.lot_id.push(lotValue);
                this.model.number_hour.push(laborDetail.number_hours);
                this.model.quantity.push(laborDetail.quantity);
                this.model.service_order.push(laborDetail.service_order);
                this.model.observation_details.push(laborDetail.observations);
                this.model.add_increment.push(laborDetail.add_increment);
                this.model.altitude.push(laborDetail.altitude);
                this.model.latitude.push(laborDetail.latitude);
                this.model.longitude.push(laborDetail.longitude);
                if (lotValue !== 0) {
                  this.typeCaptureValidate.push(false);
                } else {
                  this.typeCaptureValidate.push(true);
                }
                this.model.nLaborsCatch++;
              });
            });
            this.showHideLoading();
          } else {
            this.showHideLoading();
          }
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
    getWorkerByFarm(farmId, index, changeFarmIdOrigin = null) {
      this.workersByFarm[index - 1] = this.workers.filter(
        (worker) => worker.farm_id === farmId
      );
      if (isset(changeFarmIdOrigin)) {
        this.model.worker_id[index - 1] = null;
      }
    },
    getDataRegisterForDelete(index) {
      const workerId = this.model.worker_id[index];
      const activityId = this.model.activities_id[index];

      const workerSearch = this.workers.find(
        (worker) => worker.id === workerId
      );
      const activitySearch = this.activities.find(
        (activity) => activity.id === activityId
      );
      return `${workerSearch.name}-${activitySearch.name}`;
    },
    captureType(activityId, index) {
      const activity = this.activities.find(
        (activity) => activity.id === activityId
      );
      if (isset(activity)) {
        this.catch_type[index - 1] = activity.catch_type;
        this.model.production_unit[index - 1] = activity.production_unit;
        const capitalizedCatchType = capitalizeString(activity.catch_type);
        if (capitalizedCatchType === 'Lote') {
          this.typeCaptureValidate[index - 1] = false;
        } else {
          this.model.lot_id[index - 1] = 0;
          this.typeCaptureValidate[index - 1] = true;
        }
      }
    },
    setDeleteLaborCatchs(index) {
      if (isset(this.model.labor_detail_id[index])) {
        this.model.delete_labors_details_id.push(
          this.model.labor_detail_id[index]
        );
        this.model.delete_labors_headers_id.push(
          this.model.labor_header_id[index]
        );
      }
    },
    registerSelectDelete(index) {
      this.setDeleteLaborCatchs(index);
      this.model.labor_header_id.splice(index, 1);
      this.model.labor_detail_id.splice(index, 1);
      this.model.farm_id.splice(index, 1);
      this.model.date_save.splice(index, 1);
      this.model.hour.splice(index, 1);
      this.model.closing.splice(index, 1);
      this.model.farm_id_origin.splice(index, 1);
      this.model.worker_id.splice(index, 1);
      this.model.signature.splice(index, 1);
      this.model.lot_id.splice(index, 1);
      this.model.activities_id.splice(index, 1);
      this.model.time_type_id.splice(index, 1);
      this.model.production_unit.splice(index, 1);
      this.model.quantity.splice(index, 1);
      this.model.number_hour.splice(index, 1);
      this.model.latitude.splice(index, 1);
      this.model.longitude.splice(index, 1);
      this.model.altitude.splice(index, 1);
      this.model.service_order.splice(index, 1);
      this.model.observation_details.splice(index, 1);
      this.model.nLaborsCatch--;
      this.model.user_id.splice(index, 1);
      this.catch_type.splice(index, 1);
      this.workersByFarm.splice(index, 1);
      this.typeCaptureValidate.splice(index, 1);
    },
    handleDelete(index) {
      if (
        isset(this.model.worker_id[index]) &&
        isset(this.model.activities_id[index])
      ) {
        SweetAlert.delete(this.getDataRegisterForDelete(index)).then(
          (result) => {
            if (result.value) {
              this.registerSelectDelete(index);
            }
          }
        );
      } else {
        this.registerSelectDelete(index);
      }
    },
    confirmDelete() {
      if (this.model.labor_detail_id) {
        SweetAlert.delete(
          i18n.t('sweet_alert.jobs.delete_laborCatchs'),
          i18n.t('common_words.all_associated_records2')
        ).then((result) => {
          if (result.value) {
            this.deleteLaborCatchs();
          }
        });
      } else this.cleanForm();
    },
    deleteLaborCatchs() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'works/workers/delete';
        this.model.id = this.model.labor_header_id[0];
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.showLaborCatch = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              i18n.t('show_notification.jobs.labor_capture_deleted'),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },
    validateTotalNumberHours(index, workerId, farmIdOrigin) {
      let totalHoursN = 0;
      for (let i = 0; i < this.model.nLaborsCatch; i++) {
        if (
          this.model.worker_id[i] === workerId &&
          this.model.farm_id_origin[i] === farmIdOrigin
        ) {
          totalHoursN = totalHoursN + parseFloat(this.model.number_hour[i]);
          if (totalHoursN > 12) {
            SweetAlert.warning(i18n.t('sweet_alert.jobs.message_hours_total'));
            this.$set(this.model.number_hour, index, 0);
          }
        }
      }
    },
    validate() {
      if (!isset(this.farm_sel)) return this.validationInputsRequired('farm');
      else if (this.date_sel == null)
        return this.validationInputsRequired('date');
      else if (this.calendar_sel == null)
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      else {
        this.messageAlert = null;
        this.showLaborCatch = true;
        this.cleanForm();
        this.loadData();
      }
    },
    async setLocation() {
      this.location = await this.getLocation();
      for (let i = 0; i < this.model.nLaborsCatch; i++) {
        this.model.latitude[i] = this.location.lat;
        this.model.longitude[i] = this.location.lng;
        this.model.altitude[i] = this.location.alt;
      }
    },
    setDataByDefault() {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const hour = `${hours}:${minutes}:${seconds}`;
      const full_date = `${this.date_sel} ${hour}`;
      for (let i = 0; i < this.model.nLaborsCatch; i++) {
        this.model.date_save[i] = this.date_sel;
        this.model.hour[i] = hour;
        this.model.closing[i] = 0;
        this.model.full_date[i] = full_date;
        this.model.add_increment[i] = 1;
        this.model.farm_id[i] = this.farm_sel;
        this.model.user_id[i] = this.$store.state.auth.user.id;
        this.model.signature[i] = '';
        if (!isset(this.model.service_order[i]))
          this.model.service_order[i] = '';
        if (!isset(this.model.observation_details[i]))
          this.model.observation_details[i] = '';
      }
    },
    validateEveryDetail() {
      for (let i = 0; i < this.model.nLaborsCatch; i++) {
        if (!isset(this.model.farm_id_origin[i]))
          return this.validationInputsRequired('farm_id_origin');
        else if (!isset(this.model.worker_id[i]))
          return this.validationInputsRequired('worker');
        else if (!isset(this.model.activities_id[i]))
          return this.validationInputsRequired('activities');
        else if (!isset(this.model.time_type_id[i]))
          return this.validationInputsRequired('timeTypes');
        else if (!isset(this.model.lot_id[i]))
          return this.validationInputsRequired('lots');
        else if (!ifExistNumber(this.model.quantity[i]))
          return this.validationInputsRequired('quantity');
        else if (!ifExistNumber(this.model.number_hour[i]))
          return this.validationInputsRequired('number_hour');
      }
      this.storeUpdateLaborCatchs();
    },
    async storeUpdateLaborCatchs() {
      this.setDataByDefault();
      this.showHideLoading(true);
      if (this.isCreate() || this.isUpdate()) {
        this.model.route = 'works/workers/catchs';
        try {
          await this.setLocation();
          if (isset(this.model.labor_header_id)) {
            this.model.route = 'works/workers/updatecatchs';
            Axios.saveMaster(this.model)
              .then((response) => {
                this.showHideLoading();
                SweetAlert.success(response.data.message).then(() => {
                  this.showLaborCatch = false;
                  this.cleanForm();
                });
              })
              .catch((error) => {
                this.showHideLoading();
                this.showMessageErrors(error);
              });
          } else {
            Axios.saveMaster(this.model)
              .then((response) => {
                this.showHideLoading();
                SweetAlert.success(response.data.message).then(() => {
                  this.showLaborCatch = false;
                  this.cleanForm();
                });
              })
              .catch((error) => {
                this.showHideLoading();
                this.showMessageErrors(error);
              });
            this.showHideLoading();
          }
        } catch (error) {
          this.showHideLoading();
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('works/workers'),
        Axios.getMasters('works/activitiesgroups'),
        Axios.getMasters('works/timetypes/field'),
      ])
        .then((response) => {
          const [
            responseFarm,
            responseWorkers,
            responseActiviesGroups,
            responseTimeTypes,
          ] = response;
          this.farms = responseFarm.data.data;
          this.workers = this.concatAll(responseWorkers.data.data);
          this.activitiesGroup = responseActiviesGroups.data.data;
          this.timeTypes = responseTimeTypes.data.data;
          const activities = this.activitiesGroup.map(
            (activity) => activity.activities
          );
          this.activities = activities.reduce(
            (acc, val) => acc.concat(val),
            []
          );
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works');
  },
  destroyed() {
    this.deselectedItemOnMenu('works');
  },
};
</script>
<style scoped>
.table-responsive {
  overflow-x: auto !important;
}
</style>
